import React, { lazy, useContext } from "react";
import BreadcrumbNav from "./components/BreadcrumbNav";
import CustomNavigationBar from "./components/CustomAppBar/CustomNavigatioBar"
import {TextBox} from "./components/TextBox";
import CustomAccordion from "./components/CustomAccordion";
import { CUSTOM_APP_BAR_TEXT, FR_CLOTHING, PATH,RENTAL_TEXTILE_LAUNDRY } from "./constants";
import DisabledTextField from "./components/DisabledTextField";
import { useState } from "react";
import GenericForm from "./components/GenericForm";
import { Box, TextField, Typography } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';



const UserFRClothing = () => {
   
    const paths = [
        { url: "/", label: RENTAL_TEXTILE_LAUNDRY.HOME_LABEL },
        {
          url: PATH.userProfileSelectionPath,
          label: RENTAL_TEXTILE_LAUNDRY.USER_PROFILE_SELECTION_LABEL,
        },
        {
          url: PATH.frClothingPath,
          label: 'End User',
        },
      ];
    


    const [tabValue, setTabValue] = useState(0);
    const tabTexts = FR_CLOTHING.tabTexts;
    const currentTexts = tabTexts[tabValue] || {};
    const handleTabChange = ( newValue) => {
      setTabValue(newValue);
    };
    const [currency, setCurrency] = useState('USD');




    const section_1_rows = [
        {
            title: FR_CLOTHING.OVERALL_COST_DESCRIPTION,
            description: FR_CLOTHING.OVERALL_COST_SUBTITLE,
            fields: [
                {
                label : FR_CLOTHING.OVERALL_COST_LABELS[0],
                width: '360px',
                component: [
                <TextField size="small" disabled className="textFieldCustom" defaultValue={'NC with Ecoforce'} />,
                <TextField size="small" className="textFieldCustom"  label='Enter fabric' />
                ]
            },{
                label : FR_CLOTHING.OVERALL_COST_LABELS[1],
                width: '360px',
                component: [
                <TextField select size="small" className="textFieldCustomLong"  label='select currency'  />
                ]
            },{
                label : FR_CLOTHING.OVERALL_COST_LABELS[2],
                width: '360px',
                component: [
                <TextField size="small" type="number" className="textFieldCustom" label='Enter value'/>,
                <TextField size="small" className="textFieldCustom"  label='Enter value' />
                ]
            },
            {
                label : FR_CLOTHING.OVERALL_COST_LABELS[3],
                width: '360px',
                component: [
                <TextField size="small" type="number" className="textFieldCustom" label='Enter value'/>,
                <TextField size="small" className="textFieldCustom"  label='Enter value' />
                ]
            },
            {
                label : FR_CLOTHING.OVERALL_COST_LABELS[4],
                width: '360px',
                component: [
                <TextField size="small" type="number" className="textFieldCustom" label='Enter value'/>,
                <TextField size="small" className="textFieldCustom"  label='Enter value' />
                ]
            },
        ]
        },
        {
            title: FR_CLOTHING.REIMPREGNATION_DESCRIPTION,
            description: FR_CLOTHING.REIMPREGNATION_SUBTITLE_TEXT,
            fields: [
              {
                label: 'Cost of reimpregnation per wash per garment:',
                width: '360px',
                component: [
                <TextField size="small" type="number" className="textFieldCustom" />,
                <TextField select label='Currency' size="small" className="textFieldCustom" value={currency}>,
                  <MenuItem value="USD">USD</MenuItem>
                  <MenuItem value="EUR">EUR</MenuItem>
                </TextField>
              ]
              },
              {
                label: 'Yearly volume of garments being re-impregnated', name: 'volume',
                component: [
                <TextField type="number" size="small" className="textFieldCustom" />,
                <TextField size="small" className="textFieldCustom" disabled defaultValue='eaches / year' />
                ]
              },
              {
                label: 'Over 100 cleaning cycles',
                width: '360px',
                component: [<TextField size="small" className="textFieldCustomLong" disabled defaultValue='eaches' />
                ]
              }
      
            ],
            onSubmit: (data) => console.log('Form 1 data:', data),
          }
    ]

   const section_2_rows=[
      {  
      fields:[
        {
          label: '',
          width: '360px',
          component: [
            <Typography fontFamily={"DiodrumSemibold"} fontSize={"12px"}>Nomex® Comfort with EcoForce™</Typography>,
            <Typography fontFamily={"DiodrumSemibold"} fontSize={"12px"} textAlign={'left'} >Your incumbent Solution </Typography>,
          ]
        },
        {
          label: 'Standard washing temperature (°C)',
          sublabel: '(Based on average load of a washing machine)',
          width: '360px',
          component: [
            <DisabledTextField id="filled-disabled" sx={{ width: "185px" }} size="small" defaultValue={0} variant="filled" />,
            <TextField size="small" className="textFieldCustom" />,
          ]
        },
        {
          label:'Standard drying temperature (°C):',
          sublabel: '(Based on average load of a washing machine)',
          width: '360px',
          component: [
            <DisabledTextField id="filled-disabled" sx={{ width: "185px" }} size="small" defaultValue={0} variant="filled" />,
            <TextField size="small" className="textFieldCustom" />,
          ]
        },
        {
          label:'Washing and drying cycle duration (hrs):',
          width: '360px',
          component: [
            <TextField size="small" className="textFieldCustom" />,
            <TextField size="small" className="textFieldCustom" />,
          ]
        },

        ],
        onSubmit: (data) => console.log('Form section 2 data:', data),
      }
    ]
    
    const section_1 = [
        {
            title: FR_CLOTHING.OVERALL_COST_TITLE,
            content:(
                <GenericForm
                    title={FR_CLOTHING.OVERALL_COST_DESCRIPTION}
                    description={FR_CLOTHING.OVERALL_COST_SUBTITLE}
                    fields={section_1_rows[0].fields}
                    onSubmit={(data) => console.log('Form 1 data:', data)}
                />
            )
        },
        {
          title: RENTAL_TEXTILE_LAUNDRY.OVERALL_COST_TITLE,
          content:(
                <GenericForm
                    title={section_1_rows[1].title}
                    description={section_1_rows[1].description}
                    fields={section_1_rows[1].fields}
                    onSubmit={(data) => console.log('Form 1 data:', data)}
                />
          )
        }
    ];
    
    
    const section_3 = [];


    return (
        <div className="padding-l-r">
          
          <BreadcrumbNav paths={paths} />
          <CustomNavigationBar onTabChange={handleTabChange} 
          label1={CUSTOM_APP_BAR_TEXT.ESTIMATED_COST}
          label2={CUSTOM_APP_BAR_TEXT.ENERGY_EFFICIENCY} 
          label3={CUSTOM_APP_BAR_TEXT.ENVIRONMENT}
          />
          {/* map this into key value pairs */}
          <TextBox
            className="info-text-fr-clothing"
            p1={currentTexts.p1}
            p2={currentTexts.p2}
            p3={currentTexts.p3}
          />
          {console.log('tabValue', tabValue)}
          {(tabValue === 0) && (
            <CustomAccordion
              sections={section_1}
            />
          )}
          {(tabValue === 1) && (
            <Box style={{ display: 'flex', justifyContent: 'center' }}>            <GenericForm
            fields={section_2_rows[0].fields}
            onSubmit={(data)=>console.log('form section 2',data)}
            />
            </Box>

            
          )}
          {(tabValue === 2) && (
            <CustomAccordion
              sections={section_3}
            />)}
        </div>
      );
    };

export default UserFRClothing;
    